import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SPONSORSHIP_UPDATE, {
      pathParams: { id },
    })
  },
  method: 'PATCH',
  format(payload) {
    const { bannerImageUrl } = payload || {}
    return { bannerImageUrl }
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update sponsorship',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Sponsorisation mise à jour',
      data: raw.data,
    }
  },
}
